export default {"src":"/_next/static/media/zero-percent-outline.711920f0.svg","height":407,"width":558,"blurWidth":0,"blurHeight":0};